import type { ReactNode } from 'react';
import { Group, Stack, Text, Title } from '@mantine/core';

/**
 * Reusable page-title block (design-uplift goal, leverage point 4): a title, one
 * line of plain-English "what this screen is for" copy, and an optional
 * right-aligned actions slot (buttons/filters) — matching the new visual
 * language (theme.ts's heading scale) established on Home. Deliberately
 * presentational and self-contained (no data-fetching, no route awareness) so
 * every screen can drop it in the same way; a follow-up wave rolls this out
 * across the rest of the app, so its API is kept minimal on purpose rather than
 * growing extra props no current caller needs yet.
 */
export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
}): JSX.Element {
  return (
    <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
      <Stack gap={4} style={{ minWidth: 0 }}>
        <Title order={2}>{title}</Title>
        {description && (
          <Text c="dimmed" size="sm" maw={560}>
            {description}
          </Text>
        )}
      </Stack>
      {actions && (
        <Group gap="sm" wrap="wrap">
          {actions}
        </Group>
      )}
    </Group>
  );
}
